import i18n from '../i18n';

export function color(partType) {
    switch (partType) {
        case i18n.t('device.detail.bw'):
            return "rgba(154,154,154,1)";
        case i18n.t('device.detail.color'):
            return "rgba(255,180,129,1)";
        case "BlackToner":
            return "rgba(26,26,26,0.8)";
        case "CyanToner":
            return "rgb(0,255,255)";
        case "MagentaToner":
            return "rgb(255,0,255)";
        case "YellowToner":
            return "rgb(255,255,0)";
        case "BlackDrum":
            return "rgba(21,23,25,0.8)";
        case "CyanDrum":
            return "rgba(0,153,153,0.8)";
        case "MagentaDrum":
            return "rgba(105,0,105,0.8)";
        case "YellowDrum":
            return "rgba(203,203,16,0.8)";
        case "Drum":
            return "rgba(120,133,139)";
        case "Developer":
            return "rgb(187, 0, 33)";
        case "ImagingUnit":
            return "rgb(127,118,121)";
        case "TransferRoller":
            return "rgba(109,135,97,0.8)";
        case "Belt":
            return "rgba(159,106,87,0.8)";
        case "Fuser":
            return "rgba(253,116,89,0.8)";
        case "MaintenanceKit":
            return "rgb(192,203,255)";
        case "OzoneFilter":
            return "rgba(189,224,255,0.8)";
        case "Wastetank":
            return "rgba(184,184,184,0.8)";
    }
}

export function getFillStyle(partType) {
    return {
        background: `${color(partType)}`,
        border: '1px solid rgba(0, 0, 0, 0.7)'
    };
}

export function getClassProgress(value) {
    if (value > 50)
        return 'high';
    if (value >= 10 && value <= 50)
        return 'medium';
    if (value < 10)
        return 'low';
}